import { Optional, SystemSettingsTemplate } from '../../../types/common';
import { EmitterData } from '../../../types/systems';

export const emittersSettingsTemplate: SystemSettingsTemplate<EmitterData> = {
	sections: {
		'Radio propagation': {
			radio_parameters: { type: 'radio-parameters' },
		},
		Marks: {
			base_range: { type: 'slider', max_limit: 100000, step: 1000, unit: 'm' },
			role: {
				type: 'select',
				data: [
					{ value: 'Comms link', label: 'Comms link' },
					{ value: 'Jammer', label: 'Jammer' },
					{ value: 'Radar Jammer', label: 'Radar Jammer' },
					{ value: 'SIGINT sensor', label: 'SIGINT sensor' },
				],
			},
			is_relay: 'checkbox',
			bandwidth: {
				type: 'slider',
				max_limit: 1000000,
				unit: 'Kbps',
			},
			protocol_ids: {
				type: 'multi-checkbox',
				label: 'Protocols',
				value_type: 'number',
				data: [],
			},
		},
		Confounders: {
			confounders: {
				type: 'static-table',
				columns: { type: 'Type', degradation_percent: 'Degradation (%)' },
				use_archetypes: false,
				editable: false,
			},
		},
		Emitter: {
			side: {
				type: 'select',
				data: [
					{ value: '2', label: 'NONE' },
					{ value: '0', label: 'BLUE' },
					{ value: '1', label: 'RED' },
				],
			},
			cost: 'text',
			name: 'text',
		},
	},
};

export const defaultSettings: Optional<EmitterData, 'id'> = {
	base_range: 0,
	role: 'Comms link',
	is_relay: false,
	confounders: [],
	name: 'New emitter',
	side: 0,
	cost: '0',
	bandwidth: 10,
	protocol_ids: [1],
};
